/**
 * @generated SignedSource<<536513fe58ab8601284e081693cde16e>>
 * @relayHash ba12a427359e5d16e520af1be52586a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c874d932e50c5f6b0294ae03b5f50be90d3d6e819ce609deb39d0ce1144c457

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentLandingPageQuery } from './VirtualAgentLandingPageQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import showNextStepsEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-next-steps.relayprovider';
import vaStatusHeaderEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-status-header.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentLandingPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6c874d932e50c5f6b0294ae03b5f50be90d3d6e819ce609deb39d0ce1144c457",
    "metadata": {},
    "name": "VirtualAgentLandingPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": vaStatusHeaderEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": showNextStepsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
